<template>
    <div class="past-stories">
        <b-container fluid class="list">
            <b-row class="title" fluid>
                <b-col class="list-title">
                    {{pastStories.title}}
                </b-col>
            </b-row>
        </b-container>
        <ScrollList :items="pastStories.items" :cols="4" :control=true class="product-list-container" @click="goToPage">
            <template v-slot:default="{card}">
                <h4>{{card.name}}</h4>
                <b-card-text class="desc">
                    {{card.desc}}
                </b-card-text>
                <a :href="card.parentPath + card.slug" onclick="return false">
                    <b-card-text class="link" @click="goToPage(card.slug)">
                        {{card.link}}
                    </b-card-text>
                </a>
            </template>
        </ScrollList>
    </div>
</template>
<script>
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'pastStories',
        props: {
            pastStories: Object
        },
        components: {
            ScrollList
        },
        methods: {
            goToPage(slug) {
                this.$router.push({
                    path: '/stories/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>

    .en {
        .past-stories /deep/ h4 {
            margin-bottom: 10px !important;
            font-size: 14px !important;
            font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
            white-space: nowrap;
        }

        .past-stories /deep/ .card-text {
            font-size: 12px !important;
            line-height: 22px !important;

            &.desc {
                height: 90px;
            }

            &.link {
                margin-top: 10px !important;
            }
        }
    }

    .product-list-container /deep/ .list-item{
         .col-3 {
            flex: 0 0 20% !important;
            max-width: 20% !important;
        }
    }

    .past-stories /deep/ h4 {
        margin-top: 20px;
        margin-bottom: 25px;
        font-size: 18px;
        line-height: 30px;
        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
    }

    .past-stories /deep/ .desc {
        height: 80px;
        margin-bottom: 30px;
        font-size: 14px;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: justify;
    }

    .past-stories /deep/ .link {
        margin-top: 31px;
        font-size: 14px;
        line-height: 20px;
        text-decoration: underline;
        cursor: pointer;
        transition: font-weight .3s;
    }

    .past-stories /deep/ .list {
        .list-item {
            margin-left: -10px;
            margin-right: -10px;
        }

        .col {
            padding: 0 10px !important;
        }
    }
</style>
